import React from 'react';
import SSO from 'sso-helper';
import withConfig from 'with-config';

import * as oh from '../../helpers/output_helpers';
import {withRouter} from 'react-router';

import Spinner from '../base/Spinner';

class SSOComponent extends React.Component {
  constructor(props) {
    super(props);

    if (!window.sso) {
      let sso_config = null;
      if (this.props.config.api.hasOwnProperty('sso')) {
        sso_config = {
          login_uri: this.props.config.api.sso.login_uri,
          token_provider_uri: this.props.config.api.sso.api_uri,
          jwt_acquire_callback: () => {
            props.history.push(props.location.pathname);
          },
          jwt_release_callback: () => {
            props.history.push('/');
          },
        };
      }
      window.sso = new SSO(this.props.config.service_name, sso_config);
      window.sso.init().then(() => {
        if (!window.sso.isLoggedIn()) {
          let returnUrl = '';
          console.log('NODE_ENV: ', process.env.NODE_ENV);
          console.log('production: ', this.props.config.production);
          if (!this.props.config.production) {
            returnUrl = 'http://localhost:3000/';
          } else {
            returnUrl = this.props.config.dashboard.root_uri;
          }
          document.location =
            this.props.config.api.sso.login_uri +
            '/login' +
            '?service=' +
            encodeURIComponent(this.props.config.service_name) +
            '&returnUrl=' +
            encodeURIComponent(returnUrl);
          return;
        }
      });
    }
  }

  render() {
    if (!window.sso.isLoggedIn()) {
      return <Spinner text={oh.translate('loading')} />;
    }

    return <div>{this.props.children}</div>;
  }
}

export default withConfig(withRouter(SSOComponent));



// WEBPACK FOOTER //
// ./src/components/views/LoginCheckView.jsx